import Grid2 from '@mui/material/Grid2';
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { useWorkOrdersContext } from "../context/workOrdersContext";
import { cmmsTheme } from "@setup/theme/cmms-theme";
import { getCraftLetter } from "@/utils/craftLetter";

type Props = {};

export const CraftsFilter = ({}: Props) => {
	const { state } = useWorkOrdersContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const craft = searchParams.get("craft") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("craft", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box>
			<FormControl
				variant="outlined"
				margin="dense"
				fullWidth>
				<InputLabel id="crafts-select-label">Crafts</InputLabel>
				<Select
					labelId="crafts-select-label"
					id="crafts-select"
					value={craft}
					onChange={handleFilter}
					label="Crafts"
					style={cmmsTheme.styles.filterSelect}>
					{state.crafts.map((craft) => {
						return (
							<MenuItem key={`logId-${craft.id}`} value={craft.id}>
								<Grid2 container alignItems="center">
									<div
										style={{
											height: 20,
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											paddingLeft: 10,
										}}>
										<div
											style={{
												height: 24,
												width: 24,
												borderRadius: 4,
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												background: craft.color || cmmsTheme.colors.surfaceWhite,
											}}>
											<div
												style={{
													color: cmmsTheme.colors.surfaceWhite,
													fontWeight: 600,
													margin: "auto 0",
												}}>
												<div>{getCraftLetter(craft.description, craft.code)}</div>
											</div>
										</div>
									</div>
									<div style={{ marginLeft: 10 }}>{craft.description}</div>
								</Grid2>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
